// src/components/RecuperarPasswordModal.jsx
// Flujo "olvidé mi contraseña" para ejecutivos (admin / supervisor /
// maestro / gerencia / superadmin). Usa Supabase Auth nativo:
// resetPasswordForEmail manda email con magic link → redirige a
// /reset-password con un token en el hash → componente
// ResetPasswordPage permite setear la nueva clave.

import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { supabase } from '../lib/supabase';

export default function RecuperarPasswordModal({ onClose, emailInicial = '' }) {
  const [email, setEmail] = useState(emailInicial);
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) { setError('Ingresa tu email'); return; }
    setLoading(true); setError(null);
    try {
      const redirectTo = `${window.location.origin}/reset-password`;
      const { error: err } = await supabase.auth.resetPasswordForEmail(
        email.trim().toLowerCase(),
        { redirectTo }
      );
      if (err) throw err;
      setEnviado(true);
    } catch (e) {
      setError(e.message || 'No se pudo enviar el email. Prueba de nuevo.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--bg-card)',
          border: '0.5px solid var(--border-200)',
          borderRadius: 12,
          padding: '24px 28px',
          maxWidth: 420,
          width: '100%',
          boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {enviado ? (
          <>
            <h2 style={{ margin: '0 0 8px', fontSize: 18, color: 'var(--text-strong)' }}>
              <Mail size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /> Revisá tu email
            </h2>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--text-soft)', lineHeight: 1.55 }}>
              Te enviamos un link a <strong>{email}</strong>. Haz click ahí
              y vas a poder elegir una contraseña nueva.
            </p>
            <p style={{ margin: '0 0 18px', fontSize: 11.5, color: 'var(--text-muted)', fontStyle: 'italic' }}>
              Si no lo ves en unos minutos, revisa la carpeta de spam o prueba
              de nuevo con otro email.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  padding: '9px 18px', background: 'var(--vera-orange)', color: '#fff',
                  border: 0, borderRadius: 8, fontFamily: 'inherit', fontSize: 13,
                  fontWeight: 700, cursor: 'pointer',
                }}
              >
                Cerrar
              </button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 style={{ margin: '0 0 6px', fontSize: 18, color: 'var(--text-strong)' }}>
              Recuperar contraseña
            </h2>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Te mandamos un email con un link para elegir una contraseña nueva.
            </p>

            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-muted)', marginBottom: 4 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tucorreo@inmobiliaria.cl"
              required
              autoFocus
              style={{
                width: '100%', padding: '10px 12px',
                border: '0.5px solid var(--border-200)', borderRadius: 6,
                background: 'var(--bg-app)', color: 'var(--text-strong)',
                fontFamily: 'inherit', fontSize: 14,
              }}
            />

            {error && (
              <p style={{ margin: '10px 0 0', padding: '8px 12px', background: 'rgba(220,38,38,0.10)', color: '#dc2626', borderRadius: 6, fontSize: 12.5 }}>
                {error}
              </p>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                style={{
                  padding: '9px 16px', background: 'transparent',
                  color: 'var(--text-soft)', border: '0.5px solid var(--border-200)',
                  borderRadius: 8, fontFamily: 'inherit', fontSize: 13,
                  fontWeight: 600, cursor: 'pointer',
                }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '9px 18px', background: 'var(--vera-orange)', color: '#fff',
                  border: 0, borderRadius: 8, fontFamily: 'inherit', fontSize: 13,
                  fontWeight: 700, cursor: loading ? 'wait' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? 'Enviando…' : 'Enviar email'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
